module.exports = __webpack_public_path__ + "img/Puente_Istobal_MWASH3PROUSA_Alto_Blanco-default-back.867df84d.jpg";